import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import first from 'lodash/first';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import RequestStatus from './RequestStatus';
import { loadErrorMessage } from '../services/requests';

import { SET_APP_CONFIG } from '../redux/app'
import { SET_GUESTS, SET_EVENT_TYPE, SET_URL_DATE } from '../redux/quote';

function App({ children, dispatch, config }) {
  const { slug, date } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    if (date) {
      const urlDate = moment(date, 'DD-MM-YYYY');
      dispatch({ type: SET_URL_DATE, payload: urlDate });
    }
  }, [date, dispatch]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    const url = (!isUndefined(process.env.APP_URL)) ? process.env.APP_URL : 'https://app.cordero.cloud';
    const publicUrl = (!isUndefined(process.env.PUBLIC_URL)) ? process.env.PUBLIC_URL : 'https://portal.cordero.cloud';
    axios
      .get(`${url}/api/app/${slug}`)
      .then((response) => {
        if (!active) return;
        const storeData = response.data;
        storeData.key = slug;
        storeData.appUrl = url;
        storeData.publicUrl = publicUrl;

        dispatch({
          type: SET_EVENT_TYPE,
          payload: first(storeData.bookingTypes),
        });

        dispatch({
          type: SET_GUESTS,
          payload: storeData.guestTypes,
        });

        dispatch({
          type: SET_APP_CONFIG,
          payload: storeData,
        });

        setLoading(false);
      })
      .catch((error) => {
        if (!active) return;
        setLoading(false);
        setError(loadErrorMessage(error, 'this quote'));
      });
    return () => { active = false; };


      
  }, [dispatch, slug, retry]);

  if (loading || error || isEmpty(config)) {
    return <RequestStatus loading={loading} error={error} onRetry={() => setRetry(retry + 1)} />;
  }

  return children;
}

App.propTypes = {
  children: PropTypes.element.isRequired,
  dispatch: PropTypes.func,
  config: PropTypes.shape({}),

};

const mapStateToProps = (state) => ({ config: state.config });

export default connect(mapStateToProps)(App);
